import fileExtension from 'file-extension';

export const getFileExtension = (src = '') => {
  let ext = fileExtension(src);

  if(ext) {
    if(ext.indexOf('?') > -1) {
      ext = ext.split('?')[0];
    }

    return ext;
  }
}

export const getMimeType = extension => {
  return extension && formatMapping[extension];
};

export const formatMapping = {
  'mp4': 'video/mp4'
};


// WEBPACK FOOTER //
// ./src/Services/Misc/media.js